import React from 'react';
import { Modal } from 'react-bootstrap';

const PrintModeModal = ({
    show,
    onHide,
    title,
    options,               // Array of dropdown options [{ value: 'Native', label: 'Native' }, ...]
    selectedValue,         // Currently selected dropdown value (from Redux state)
    onSelectChange,        // Handler when dropdown changes
    onSubmit,              // Submit button handler
    onCancel,              // Cancel button handler
    submitText = 'Submit',
    cancelText = 'Cancel',
}) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={true}
            className="clsQuickAssign"
        >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <select
                    className="form-control"
                    value={selectedValue}
                    onChange={(e) => onSelectChange(e.target.value)}
                >
                    {options.map((opt, idx) => (
                        <option key={idx} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            </Modal.Body>

            <Modal.Footer>
                <button
                    className="focusClass btn btn-red OrangeShadow"
                    onClick={onSubmit}
                >
                    {submitText}
                </button>
                <button
                    id="ChangePrinters"
                    className="focusClass btn btn-red OrangeShadow"
                    onClick={onCancel}
                >
                    {cancelText}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default PrintModeModal;
